<template>
  <div class="withdrawals-finder">
    <div class="row">
      <div class="p-4 flex">
        <vs-input
          class="mr-4"
          label="Fecha inicio"
          type="date"
          v-model="filter.date.start"></vs-input>

        <vs-input
          class="mr-4"
          label="Fecha fin"
          type="date"
          v-model="filter.date.end"></vs-input>

        <div>
          <vs-input
            class="mr-4"
            text="hello"
            label="Buscar retiro"
            v-model="filter.q"></vs-input>
          <small>{{ label }}</small>
        </div>

        <div class="pt-6">
          <vs-button
            @click="submited()"
            icon="search"></vs-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";

export default {
  props: ["label"],
  data: () => ({
    filter: {
      q: '',
      date: {
        start: '',
        end: ''
      }
    }
  }),
  mounted() {
    this.filter.date.start = moment().startOf('month').format("Y-MM-DD");
    this.filter.date.end = moment().format("Y-MM-DD");
  },
  methods: {
    submited() {
      this.$emit('onSubmit', this.filter)
    }
  }
}
</script>
